/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CreateOrderService {
  private orderState = new Subject<any>();
  private state = new BehaviorSubject<boolean>(false);
  private skipCreateOrder = new BehaviorSubject<boolean>(false);

  state$ = this.state.asObservable();
  skipCreateOrder$ = this.skipCreateOrder.asObservable();
  constructor() {}

  setState(value: boolean) {
    this.state.next(value);
  }

  getState() {
    return this.state.getValue();
  }

  setSkipCreateOrder(value: boolean) {
    this.skipCreateOrder.next(value);
  }

  getSkipCreateOrder() {
    return this.skipCreateOrder.getValue();
  }

  setOrderState(newState: any) {
    this.orderState.next(newState);
  }

  getOrderState(): Observable<any> {
    return this.orderState.asObservable();
  }
}
